import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import CreateEmployer from './CreateContact';
import { getAllEmployers } from '../../../actions/employers';
import ListPageHeader from '../../common/lists/ListPageHeader';
import PaginationBaseComponent from '../../common/PaginationBaseComponent';
import ListItemContact from '../../common/lists/ListItem/ListItemContact';
import { setContactsFilterParams } from '../../../helpers/contacts';
import _ from 'lodash';
import { debounceDefault } from '../../../constants/ui';
import Close from '../../common/ui/Close';
import qs from 'qs';

class Employers extends PaginationBaseComponent {
  static propTypes = {
    initialData: PropTypes.array.isRequired,
    pagesQuantity: PropTypes.number.isRequired
  };

  constructor (props) {
    super(props);

    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    this.initialState = { full_name: '' };

    this.state = {
      full_name: query.full_name || this.initialState.full_name,
      activePage: this.getActivePage(),
      loading: false,
      modalIsOpen: false, // for creation company,
      goToPageBtnIsShown: false
    };

    this.handleInputChangeDebounce = _.debounce(this._loadData, debounceDefault);
  }

  componentDidMount () {
    this._loadData(this.state.activePage);
  }

  _loadData = (activePage = this.state.activePage) =>
    this.loadData(activePage, setContactsFilterParams(this.state));

  toggleModal = () => {
    this.setState(prevState => ({
      modalIsOpen: !prevState.modalIsOpen
    }));
  };

  handleInputChange = event => this.handleSearch(event.target.value);

  handleSearch = full_name => this.setState({ full_name },
    this.handleInputChangeDebounce);

  clearSearch = () => this.handleSearch(this.initialState.full_name);

  render () {
    const { history, pagesQuantity, initialData } = this.props;
    const { loading, full_name } = this.state;

    return (
      <div>
        <ListPageHeader onClick={this.toggleModal} icon={faUsers} title='Contacts' />

        <CreateEmployer
          isOpen={this.state.modalIsOpen}
          toggleModal={this.toggleModal}
          history={history}
        />

        <div className='position-relative col-12 mb-3 p-0'>
          {!!full_name && (
            <Close onClick={this.clearSearch} className='button-clear' />
          )}

          <input
            className='input'
            name='full_name'
            value={full_name}
            placeholder={'Type contact name, email or phone number'}
            onChange={this.handleInputChange}
          />
        </div>

        <div className={`list ${loading && 'is-loading'}`}>
          {initialData.map(user => (
            <ListItemContact user={user} key={user.id} />
          ))}
        </div>

        {pagesQuantity > 1 && this.renderPagination()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    initialData: state.employers.employersList,
    pagesQuantity: state.employers.pagesQuantity
  };
};

export default connect(mapStateToProps, { getDataAction: getAllEmployers })(Employers);



// WEBPACK FOOTER //
// ./src/components/app/employersList/index.js